/* eslint-disable no-unused-vars */
import React, { useEffect } from 'react';
import {
  Box,
  Button,
  Card,
  CardBody,
  Flex,
  FormControl,
  FormLabel,
  Input,
  Text,
  Textarea,
  VStack,
  useColorModeValue,
} from '@chakra-ui/react';
import { useForm } from 'react-hook-form';
import {
  useAddCustomNotification,
  useAddGeneralInformation,
} from '../hooks/useAddGeneralInformation';
import {
  useCustomNotificationById,
  useGeneralInformationById,
} from '../hooks/useGeneralInformationById';
import {
  useUpdateCustomNotification,
  useUpdateGeneralInformation,
} from '../hooks/useUpdateGeneralInformation';

function VideoLinkForm({ editId, onSuccess, setSelectedId }) {
  const id = editId?._id;
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting },
  } = useForm({
    defaultValues: {
      name: '',
      link: '',
    },
  });

  const {
    data,
    isLoading: isIdLoading,
    isError,
  } = useGeneralInformationById(id);

  useEffect(() => {
    if (data?.data?.result) {
      reset({
        name: data.data.result.name,
        link: data.data.result.link,
      });
    }
  }, [data, reset]);

  const createMutation = useAddGeneralInformation({
    onSuccess: () => {
      reset();
      onSuccess?.();
    },
  });
  const updateMutation = useUpdateGeneralInformation({
    onSuccess: () => {
      reset();

      setSelectedId(null);
      onSuccess?.();
    },
  });

  const submitHandler = (formData) => {
    if (id) {
      updateMutation.mutate({ id: id, ...formData });
      return;
    }
    createMutation.mutate(formData);
  };

  const isLoading =
    createMutation.isPending || updateMutation.isPending || isIdLoading;

  const cardBg = useColorModeValue('white', 'gray.800');
  const cardShadow = useColorModeValue(
    'rgba(0, 0, 0, 0.35) 0px 5px 15px',
    'rgba(0, 0, 0, 0.6) 0px 5px 15px',
  );

  return (
    <Box w="100%" mt={6} display="flex" justifyContent="center">
      <Card
        w="100%"
        maxW="600px"
        rounded="xl"
        bg={cardBg}
        boxShadow={cardShadow}
      >
        <CardBody p={6}>
          <form onSubmit={handleSubmit(submitHandler)}>
            <VStack spacing={6} align="stretch">
              <FormControl isInvalid={!!errors.name}>
                <FormLabel fontWeight="bold">
                  Name{' '}
                  <Text as="span" color="red.500">
                    *
                  </Text>
                </FormLabel>
                <Input
                  placeholder="Enter Name"
                  {...register('name', {
                    required: 'Name is required',
                  })}
                />
                {errors.name && (
                  <Text color="red.500" fontSize="13px" mt={1}>
                    {errors.name.message}
                  </Text>
                )}
              </FormControl>
              <FormControl isInvalid={!!errors.link}>
                <FormLabel fontWeight="bold">
                  Youtube link{' '}
                  <Text as="span" color="red.500">
                    *
                  </Text>
                </FormLabel>
                <Input
                  placeholder="Enter Youtube link"
                  {...register('link', {
                    required: 'Youtube link is required',
                  })}
                />
                {errors.link && (
                  <Text color="red.500" fontSize="13px" mt={1}>
                    {errors.link.message}
                  </Text>
                )}
              </FormControl>

              <Flex justify="flex-end" mt={4}>
                <Button
                  type="submit"
                  colorScheme="blue"
                  isLoading={isLoading}
                  px={8}
                >
                  {editId ? 'Update' : 'Submit'}
                </Button>
              </Flex>
            </VStack>
          </form>
        </CardBody>
      </Card>
    </Box>
  );
}

export default VideoLinkForm;
